import { UrlService } from '@/common/services/url/url.service';
import { CheckReservationUseCase } from '@/core/domain/check-reservation/usecases/checkReservation.usecase';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
    selector: 'fe-view-cancel-reservation',
    templateUrl: './view-cancel-reservation.component.html',
    styleUrls: ['./view-cancel-reservation.component.scss'],
})
export class ViewCancelReservationComponent implements OnInit {
    cancelReservationForm!: FormGroup;
    lastName = '';
    reservationKey = '';

    loadingBtn = false;

    breadcrumbs = [
        {
            label: 'fe_breadcrumb_view_cancel',
            url: 'check-your-reservation',
        },
    ];

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private checkReservationUseCase: CheckReservationUseCase,
        private url: UrlService,
    ) {}

    ngOnInit(): void {
        this.cancelReservationForm = this.fb.group({
            lastName: ['', [Validators.required]],
            reservationKey: [
                '',
                [Validators.required, Validators.maxLength(11)],
            ],
        });

        if (this.cancelReservationForm.get('lastName')?.value) {
            this.lastName = this.cancelReservationForm.get('lastName')!.value;
        }

        if (this.cancelReservationForm.get('reservationKey')?.value) {
            this.reservationKey =
                this.cancelReservationForm.get('reservationKey')!.value;
        }

        this.cancelReservationForm
            .get('lastName')
            ?.valueChanges.subscribe((value) => (this.lastName = value));
        this.cancelReservationForm
            .get('reservationKey')
            ?.valueChanges.subscribe((value) => (this.reservationKey = value));
    }

    onSubmit(): void {
        if (this.cancelReservationForm.valid) {
            this.loadingBtn = true;
            const formValues = {
                reservationCode:
                    this.cancelReservationForm.get('reservationKey')?.value,
                lastName: this.cancelReservationForm.get('lastName')?.value,
            };

            const currentPrefix =
                this.activatedRoute.snapshot.pathFromRoot[1]?.url[0]?.path ||
                '';

            this.checkReservationUseCase.execute(formValues).subscribe({
                error: () => {
                    const errorMessage =
                        currentPrefix === 'es'
                            ? 'Información incorrecta'
                            : 'Invalid information';

                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `Error: ${errorMessage}`,
                    });
                    this.loadingBtn = false;
                },
                complete: () => {
                    let redirectUrl = this.url.format(
                        'reservations/reservation-information',
                    );

                    redirectUrl = [redirectUrl].join('/');

                    this.router.navigate([redirectUrl], {
                        queryParams: {
                            reservationCode: formValues.reservationCode,
                            lastName: formValues.lastName,
                        },
                    });
                },
            });
        } else {
            this.cancelReservationForm.markAllAsTouched();
        }
    }
}
